var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { Create, SaveButton, SimpleForm, Toolbar, useGetOne, useNotify, useRefresh, } from "react-admin";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CircularProgress, Checkbox, FormControlLabel, FormGroup, FormHelperText, FormLabel, FormControl, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { MANAGE_ELECTION_DATES } from "@/queries/ManageElectionDates";
import { IPermissions } from "@/types/keycloak";
import { VotingStatusChannel } from "@sequentech/ui-core";
import SelectElection from "@/components/election/SelectElection";
import { getGraphQLActionErrorReason } from "@/services/graphqlActionError";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { ZonedDateTimeField, editableOf, zonedValueOf, } from "@/components/timezones/ZonedDateTimeInput";
import { useTimeZoneContext } from "@/components/timezones/useTimeZoneContext";
import { formatWallTime, useTimeZoneService, } from "@/components/timezones/timeZoneService";
import { OutcomeChangeNotice } from "./OutcomeChangeNotice";
/**
 * A save warning's parameters in words: wall times (`…_local`, "YYYY-MM-DD HH:MM")
 * in the admin format, and the zone (`time_zone`) as its label.
 */
export var warningParams = function (warning, service, electionName) {
    var _a;
    return (__assign({ 
        // The Post the warning is about.
        election: warning.election_id ? electionName(warning.election_id) : "" }, Object.fromEntries(Object.entries((_a = warning.params) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
        var name = _a[0], value = _a[1];
        return [
            name,
            typeof value !== "string"
                ? value
                : name.endsWith("_local")
                    ? formatWallTime(value.replace(" ", "T"), service.text)
                    : name === "time_zone"
                        ? service.zoneLabel(value, service.text)
                        : value,
        ];
    }))));
};
/** Warnings the form already showed before saving. */
var DST_WARNINGS = ["dst-gap", "dst-overlap"];
export var EventProcessors;
(function (EventProcessors) {
    EventProcessors["ALLOW_INIT_REPORT"] = "ALLOW_INIT_REPORT";
    EventProcessors["START_VOTING_PERIOD"] = "START_VOTING_PERIOD";
    EventProcessors["END_VOTING_PERIOD"] = "END_VOTING_PERIOD";
    EventProcessors["ALLOW_VOTING_PERIOD_END"] = "ALLOW_VOTING_PERIOD_END";
    EventProcessors["START_ENROLLMENT_PERIOD"] = "START_ENROLLMENT_PERIOD";
    EventProcessors["END_ENROLLMENT_PERIOD"] = "END_ENROLLMENT_PERIOD";
    EventProcessors["START_LOCKDOWN_PERIOD"] = "START_LOCKDOWN_PERIOD";
    EventProcessors["END_LOCKDOWN_PERIOD"] = "END_LOCKDOWN_PERIOD";
    EventProcessors["ALLOW_TALLY"] = "ALLOW_TALLY";
    EventProcessors["START_READINESS_TEST"] = "START_READINESS_TEST";
    EventProcessors["END_READINESS_TEST"] = "END_READINESS_TEST";
    EventProcessors["START_FINAL_TESTING"] = "START_FINAL_TESTING";
    EventProcessors["END_FINAL_TESTING"] = "END_FINAL_TESTING";
    EventProcessors["START_TEST_VOTING"] = "START_TEST_VOTING";
    EventProcessors["END_TEST_VOTING"] = "END_TEST_VOTING";
})(EventProcessors || (EventProcessors = {}));
/**
 * Whether a scheduled event of this type can target one election. Enrollment
 * opens per election and still closes for the whole event.
 */
export var targetsElection = function (eventProcessor) {
    switch (eventProcessor) {
        case EventProcessors.ALLOW_INIT_REPORT:
        case EventProcessors.START_VOTING_PERIOD:
        case EventProcessors.END_VOTING_PERIOD:
        case EventProcessors.ALLOW_VOTING_PERIOD_END:
        case EventProcessors.ALLOW_TALLY:
        case EventProcessors.START_ENROLLMENT_PERIOD:
        case EventProcessors.START_READINESS_TEST:
        case EventProcessors.END_READINESS_TEST:
        case EventProcessors.START_FINAL_TESTING:
        case EventProcessors.END_FINAL_TESTING:
        case EventProcessors.START_TEST_VOTING:
        case EventProcessors.END_TEST_VOTING:
            return true;
        case EventProcessors.END_ENROLLMENT_PERIOD:
        case EventProcessors.START_LOCKDOWN_PERIOD:
        case EventProcessors.END_LOCKDOWN_PERIOD:
            return false;
    }
};
/** Whether a scheduled event of this type must target one election (otherwise it may be event-wide). */
export var requiresElection = function (eventProcessor) {
    return targetsElection(eventProcessor) &&
        ![
            EventProcessors.START_VOTING_PERIOD,
            EventProcessors.END_VOTING_PERIOD,
            EventProcessors.START_ENROLLMENT_PERIOD,
        ].includes(eventProcessor);
};
/** Opening and closing voting: the transitions with a predicted outcome (design §5c). */
export var isVotingTransition = function (eventProcessor) {
    return eventProcessor === EventProcessors.START_VOTING_PERIOD ||
        eventProcessor === EventProcessors.END_VOTING_PERIOD;
};
var VotingChannelsInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, error = _a.error;
    var t = useTranslation().t;
    var setValue = useFormContext().setValue;
    return (_jsxs(FormControl, { component: "fieldset", margin: "normal", error: !!error, children: [_jsx(FormLabel, { component: "legend", children: t("electionScreen.field.votingChannels") }), _jsx(FormGroup, { row: true, children: Object.values(VotingStatusChannel).map(function (channel) { return (_jsx(FormControlLabel, { label: t("common.channel.".concat(channel.toLowerCase())), control: _jsx(Checkbox, { checked: value.includes(channel), disabled: disabled || (value.length === 1 && value.includes(channel)), onChange: function (_, checked) {
                            var next = checked
                                ? __spreadArray(__spreadArray([], value, true), [channel], false) : value.filter(function (selected) { return selected !== channel; });
                            setValue("event_payload.voting_channels", next, {
                                shouldDirty: true,
                            });
                            onChange(next);
                        } }) }, channel)); }) }), error && _jsx(FormHelperText, { children: error })] }));
};
var CreateEvent = function (_a) {
    var _b, _c, _d, _e;
    var electionEventId = _a.electionEventId, setIsOpenDrawer = _a.setIsOpenDrawer, isEditEvent = _a.isEditEvent, selectedEventId = _a.selectedEventId, getElectionName = _a.getElectionName;
    var t = useTranslation().t;
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState([
        VotingStatusChannel.Online,
        VotingStatusChannel.Kiosk,
    ]), votingChannels = _g[0], setVotingChannels = _g[1];
    var refresh = useRefresh();
    var tenantId = useTenantStore()[0];
    var selectedEvent = useGetOne("sequent_backend_scheduled_event", { id: selectedEventId }, { enabled: !!selectedEventId }).data;
    var notify = useNotify();
    var manageElectionDates = useMutation(MANAGE_ELECTION_DATES, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE,
            },
        },
    })[0];
    var _h = useState(isEditEvent ? (_b = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_payload) === null || _b === void 0 ? void 0 : _b.election_id : null), electionId = _h[0], setElectionId = _h[1];
    var aliasRenderer = useAliasRenderer();
    var election = useGetOne("sequent_backend_election", { id: electionId }, { enabled: !!electionId }).data;
    var electionName = election ? aliasRenderer(election) : null;
    var zones = useTimeZoneContext(electionEventId);
    var timeZones = useTimeZoneService();
    // The wall time and zone as edited; the zone follows the election until one is chosen.
    var _j = useState({
        local: "",
        timezone: zones.zoneOf(null),
    }), edited = _j[0], setEdited = _j[1];
    var _k = useState(false), zoneChosen = _k[0], setZoneChosen = _k[1];
    // Whether the time was edited here; until then an edited row shows what is stored.
    var _l = useState(false), touched = _l[0], setTouched = _l[1];
    var stored = isEditEvent ? selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.cron_config : undefined;
    // An edited row whose time wasn't touched is saved as stored (seconds and all),
    // so saving its channels doesn't change its fingerprint.
    var zoned = (stored === null || stored === void 0 ? void 0 : stored.scheduled_date) && !touched && edited.local
        ? {
            scheduled_date: stored.scheduled_date,
            local: (_c = stored.local) !== null && _c !== void 0 ? _c : edited.local,
            timezone: (_d = stored.timezone) !== null && _d !== void 0 ? _d : edited.timezone,
        }
        : zonedValueOf(edited.local, edited.timezone, timeZones);
    // Only the event's configured zones can be saved.
    var unconfiguredZone = !!zoned && !zones.configured.includes(zoned.timezone);
    var _m = useState(isEditEvent
        ? ((_e = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_processor) !== null && _e !== void 0 ? _e : EventProcessors.START_VOTING_PERIOD)
        : EventProcessors.START_VOTING_PERIOD), eventType = _m[0], setEventType = _m[1];
    useEffect(function () {
        var _a, _b;
        if (!isEditEvent || !selectedEvent)
            return;
        setEventType(selectedEvent.event_processor);
        var payload = selectedEvent.event_payload;
        setElectionId((_a = payload === null || payload === void 0 ? void 0 : payload.election_id) !== null && _a !== void 0 ? _a : null);
        setVotingChannels(((_b = payload === null || payload === void 0 ? void 0 : payload.voting_channels) === null || _b === void 0 ? void 0 : _b.length)
            ? payload.voting_channels
            : [VotingStatusChannel.Online, VotingStatusChannel.Kiosk]);
    }, [isEditEvent, selectedEvent]);
    // An edited row shows its time as entered, or an older instant in the row's zone,
    // which is known once the event's zones load; the person's edits are kept.
    useEffect(function () {
        if (!isEditEvent || !selectedEvent || touched)
            return;
        var payload = selectedEvent.event_payload;
        var stored = selectedEvent.cron_config;
        setEdited(editableOf(stored, zones.zoneOf(payload === null || payload === void 0 ? void 0 : payload.election_id), timeZones));
    }, [isEditEvent, selectedEvent, touched, zones, timeZones]);
    // A new row's time is in its election's zone (else the primary) until a zone is chosen.
    useEffect(function () {
        if (isEditEvent || zoneChosen)
            return;
        var zone = zones.zoneOf(electionId);
        setEdited(function (current) { return (current.timezone === zone ? current : __assign(__assign({}, current), { timezone: zone })); });
    }, [isEditEvent, zoneChosen, zones, electionId]);
    var placeName = isEditEvent && selectedEvent
        ? getElectionName(selectedEvent)
        : electionId && targetsElection(eventType)
            ? (electionName !== null && electionName !== void 0 ? electionName : undefined)
            : t("lifecycle.schedule.allElections");
    var isVotingEvent = eventType === EventProcessors.START_VOTING_PERIOD ||
        eventType === EventProcessors.END_VOTING_PERIOD;
    // Early voting cannot start once online voting has started.
    var opensOnlineWithEarlyVoting = eventType === EventProcessors.START_VOTING_PERIOD &&
        votingChannels.includes(VotingStatusChannel.Online) &&
        votingChannels.includes(VotingStatusChannel.EarlyVoting);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var variables, _a, data, errors, saved, warnings, error_1;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (opensOnlineWithEarlyVoting || !zoned || unconfiguredZone) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    variables = {
                        electionEventId: electionEventId,
                        electionId: targetsElection(eventType) && electionId && electionId.length > 0
                            ? electionId
                            : null,
                        scheduledDate: zoned === null || zoned === void 0 ? void 0 : zoned.scheduled_date,
                        localDateTime: (stored === null || stored === void 0 ? void 0 : stored.scheduled_date) && !touched ? ((_b = stored.local) !== null && _b !== void 0 ? _b : null) : zoned === null || zoned === void 0 ? void 0 : zoned.local,
                        timeZone: (stored === null || stored === void 0 ? void 0 : stored.scheduled_date) && !touched
                            ? ((_c = stored.timezone) !== null && _c !== void 0 ? _c : null)
                            : zoned === null || zoned === void 0 ? void 0 : zoned.timezone,
                        eventProcessor: eventType,
                        votingChannels: isVotingEvent ? votingChannels : undefined,
                    };
                    return [4 /*yield*/, manageElectionDates({
                            variables: variables,
                        })];
                case 2:
                    _a = _h.sent(), data = _a.data, errors = _a.errors;
                    setIsLoading(false);
                    if (((_d = data === null || data === void 0 ? void 0 : data.manage_election_dates) === null || _d === void 0 ? void 0 : _d.error_msg) || errors) {
                        notify(t("eventsScreen.messages.createError"), { type: "error" });
                    }
                    else {
                        setIsOpenDrawer(false);
                        refresh();
                        saved = t(isEditEvent
                            ? "eventsScreen.messages.editSuccess"
                            : "eventsScreen.messages.createSuccess");
                        warnings = (_f = (_e = data === null || data === void 0 ? void 0 : data.manage_election_dates) === null || _e === void 0 ? void 0 : _e.warnings) === null || _f === void 0 ? void 0 : _f.filter(function (_a) {
                            var code = _a.code;
                            return !DST_WARNINGS.includes(code);
                        });
                        notify((warnings === null || warnings === void 0 ? void 0 : warnings.length)
                            ? __spreadArray([
                                saved
                            ], warnings.map(function (warning) {
                                return t(warning.message_key, warningParams(warning, timeZones, function (id) {
                                    return getElectionName({
                                        event_payload: { election_id: id },
                                    });
                                }));
                            }), true).join(" ")
                            : saved, { type: (warnings === null || warnings === void 0 ? void 0 : warnings.length) ? "warning" : "success", multiLine: !!(warnings === null || warnings === void 0 ? void 0 : warnings.length) });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _h.sent();
                    setIsLoading(false);
                    notify((_g = getGraphQLActionErrorReason(error_1)) !== null && _g !== void 0 ? _g : t("eventsScreen.messages.createError"), {
                        type: "error",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Create, { hasEdit: isEditEvent, children: _jsxs(SimpleForm, { onSubmit: onSubmit, toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { disabled: opensOnlineWithEarlyVoting || !zoned || unconfiguredZone, alwaysEnable: !!zoned }) }), children: [_jsx(Typography, { variant: "h4", children: t("".concat(isEditEvent ? "eventsScreen.edit.title" : "eventsScreen.create.title")) }), _jsx(Typography, { variant: "body2", children: t("".concat(isEditEvent
                        ? "eventsScreen.edit.subtitle"
                        : "eventsScreen.create.subtitle")) }), _jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { id: "event-type-select-label", children: t("eventsScreen.eventType.label") }), _jsx(Select, { required: true, name: "event_type", labelId: "event-type-select-label", label: String(t("eventsScreen.eventType.label")), value: eventType, onChange: function (e) { return setEventType(e.target.value); }, disabled: isEditEvent || isLoading, children: Object.values(EventProcessors).map(function (processor) { return (_jsx(MenuItem, { value: processor, children: t("eventsScreen.eventType.".concat(processor)) }, processor)); }) })] }), _jsx(FormControl, { fullWidth: true, children: isEditEvent ? (_jsx(TextField, { label: String(t("eventsScreen.election.label")), disabled: true, value: selectedEvent ? getElectionName(selectedEvent) : "-" })) : (targetsElection(eventType) && (_jsx(SelectElection, { isRequired: requiresElection(eventType), tenantId: tenantId, electionEventId: electionEventId, label: String(t("eventsScreen.election.label")), onSelectElection: function (electionId) { return setElectionId(electionId); }, source: "event_payload.election_id", disabled: isEditEvent || isLoading, value: electionId }))) }), isVotingEvent && (_jsx(VotingChannelsInput, { value: votingChannels, onChange: setVotingChannels, disabled: isLoading, error: opensOnlineWithEarlyVoting
                        ? t("eventsScreen.messages.onlineWithEarlyVoting")
                        : undefined })), _jsx(ZonedDateTimeField, { required: true, disabled: isLoading, label: t("lifecycle.input.scheduledAt"), local: edited.local, timezone: edited.timezone, zones: zones.configured, primary: zones.primary, place: placeName, error: unconfiguredZone, helperText: unconfiguredZone
                        ? t("lifecycle.input.unconfiguredZone", { zone: edited.timezone })
                        : undefined, onChange: function (_value, next) {
                        if (next.timezone !== edited.timezone)
                            setZoneChosen(true);
                        setTouched(true);
                        setEdited(next);
                    } }), isVotingTransition(eventType) && zoned ? (_jsx(OutcomeChangeNotice, { electionEventId: electionEventId, change: {
                        id: selectedEventId !== null && selectedEventId !== void 0 ? selectedEventId : null,
                        event_processor: eventType,
                        cron_config: zoned,
                        event_payload: {
                            election_id: targetsElection(eventType) ? electionId : null,
                            voting_channels: votingChannels,
                        },
                    }, zone: edited.timezone })) : null, isLoading ? _jsx(CircularProgress, {}) : null] }) }));
};
export default CreateEvent;
